export default class ApiError extends Error {
  requestId?: string;

  constructor(message: string, requestId?: string) {
    super(message);
    this.name = 'Api Error';
    this.requestId = requestId;
  }
}
